var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtlestone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5989",
    "data-name": "Group 5989",
    transform: "translate(-908 -401)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_329",
    "data-name": "Ellipse 329",
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(908 401)",
    fill: "#e8f1ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(935.222 433.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7132",
    "data-name": "Path 7132",
    d: "M164.323,256.162a4.162,4.162,0,1,0-8.323,0v4.162a16.647,16.647,0,1,0,33.294,0A8.323,8.323,0,0,0,180.97,252h-8.323",
    transform: "translate(-143.515 -227.862)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7133",
    "data-name": "Path 7133",
    d: "M236,116.97V96.162a4.162,4.162,0,0,1,8.323,0v12.485",
    transform: "translate(-215.191 -84.509)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7134",
    "data-name": "Path 7134",
    d: "M36,28.323l4.162,4.162L52.647,20",
    transform: "translate(-36 -20)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlestone);
export default __webpack_public_path__ + "static/media/atlestone.f10aae2a7b849d7b20fd2ae4dea5b193.svg";
export { ForwardRef as ReactComponent };